// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202604231304/js/" + chunkId + "." + {"44":"3b10d298","225":"5cc39d5a","481":"c0f5de15","486":"ca356089","770":"5a16c344"}[chunkId] + ".0.6333800850141897.chunk.js";
};